import { render, staticRenderFns } from "./modal-table.vue?vue&type=template&id=1e8f2a98&scoped=true&"
import script from "./modal-table.vue?vue&type=script&lang=js&"
export * from "./modal-table.vue?vue&type=script&lang=js&"
import style0 from "./modal-table.vue?vue&type=style&index=0&id=1e8f2a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f2a98",
  null
  
)

component.options.__file = "modal-table.vue"
export default component.exports